import React from 'react';
import cx from 'classnames';

import cardStyles from 'Components/shared/VehicleCards/VehicleCard/VehicleCardView/VehicleCardView.module.scss';
import VehicleCardPlaceholderBox from 'Components/shared/VehicleCards/VehicleCardPlaceholderBox/VehicleCardPlaceholderBox';
import { StaticComponent } from 'Utilities/hooks/hocs';

import styles from './VehicleCardLoadingView.module.scss';

const VehicleListCardLoadingView = StaticComponent(() => (
	<div className={cardStyles.vehicleListCardView}>
		<div className={styles.imagesBox}>
			<VehicleCardPlaceholderBox className={styles.imagesPlaceholder} />
		</div>
		<div className={cardStyles.detailsContainer}>
			<div className={cardStyles.topInfoBar}>
				<VehicleCardPlaceholderBox className={styles.topInfoPlaceholder} />
			</div>
			<section className={cx(cardStyles.vehicleInfoBar, styles.view)}>
				<div className={styles.titlePlaceholderBox}>
					<VehicleCardPlaceholderBox className={cx(styles.titlePlaceholder, styles.titleBoxSecondLine)} />
					<VehicleCardPlaceholderBox className={styles.titlePlaceholder} />
					<VehicleCardPlaceholderBox className={styles.titlePlaceholder} />
				</div>
				<div className={styles.specsPlaceholderBox}>
					<VehicleCardPlaceholderBox className={styles.spec} />
					<VehicleCardPlaceholderBox className={styles.spec} />
					<VehicleCardPlaceholderBox className={styles.spec} />
					<VehicleCardPlaceholderBox className={styles.spec} />
					<VehicleCardPlaceholderBox className={styles.spec} />
				</div>
				<div className={styles.statusPlaceholderBox}>
					<VehicleCardPlaceholderBox className={styles.statusDotPlaceholder} />
					<div className={styles.priceBox}>
						<VehicleCardPlaceholderBox className={styles.pricePlaceholder} />
						<VehicleCardPlaceholderBox className={styles.statusPlaceholder} />
					</div>
				</div>
			</section>
		</div>
	</div>
));

VehicleListCardLoadingView.displayName = 'VehicleListCardLoadingView';

export default VehicleListCardLoadingView;
